import React, { useEffect, useState } from "react";
import Spinner from "../common/spinner";
import { ToastContainer, toast } from "react-toastify";
import "./carLists.scss";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import * as service from "./carServices.js";

import Select from "../common/select";
import Input from "../common/input";
import { log } from "../../helper/helper";

function CarLists(props) {
  const [isLoading, setLoading] = useState(true);
  const [lists, setLists] = useState([]);
  const [FilterList, setFilterList] = useState([]);
  let target = [{ id: "1", name: "Registration Number" }];
  const [targetSelected, setTargetSelected] = useState("");
  const [filter, setFilter] = useState("");

  const getAllCars = async () => {
    try {
      const result = await service.adminCarInbox();
      log(result);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            setLists(result.data.carList);
            setFilterList(result.data.carList);
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };

  const handleFilterData = (value) => {
    setFilter(value);
    if (value !== "") {
      switch (targetSelected) {
        case "Registration Number":
          const newList = lists.filter(
            (li) =>
              li.registration_number
                .toLowerCase()
                .indexOf(value.toLowerCase()) !== -1
          );
          setFilterList(newList);
          break;
        default:
          break;
      }
    } else {
      setFilterList(lists);
    }
  };
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        props.history.replace("/login");
      }
    });

    getAllCars();
  }, []);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const handleStatus = (carLatestStatus) => {
    switch (carLatestStatus) {
      case "Approved":
        return (
          <div className="car-status">
            <span className="approved">{carLatestStatus}</span>
          </div>
        );
      case "Processing":
        return (
          <div className="car-status">
            <span className="processing">{carLatestStatus}</span>
          </div>
        );
      case "Further Investigation":
        return (
          <div className="car-status">
            <span className="further-investigation">{carLatestStatus}</span>
          </div>
        );
      case "Restricted":
        return (
          <div className="car-status">
            <span className="restricted">{carLatestStatus}</span>
          </div>
        );
      case "Rejected":
        return (
          <div className="car-status">
            <span className="rejected">{carLatestStatus}</span>
          </div>
        );
      case "Removed":
        return (
          <div className="car-status">
            <span className="removed">{carLatestStatus}</span>
          </div>
        );
      default:
        break;
    }
  };

  const handleButtonControl = (car) => {
    if (car.car_latest_status === "Processing") {
      if (car.is_allow_show_edit_button_result) {
        return (
          <button
            className="single-view"
            onClick={() =>
              props.history.push("/home/carLists/car", {
                car: car,
              })
            }
          >
            View
          </button>
        );
      } else {
        return null;
      }
    } else {
      return (
        <button
          className="single-view"
          onClick={() =>
            props.history.push("/home/carLists/car", {
              car: car,
            })
          }
        >
          View
        </button>
      );
    }
  };

  return (
    <div className="show-all-list car-list">
      <ToastContainer />
      {renderSpinner()}
      <div className="headline">
        <h3>Car List</h3>
      </div>
      <div className="filter-section">
        <div className="row">
          <div className="col-md-6">
            <Select
              name="target"
              options={target}
              onChange={(e) => {
                setTargetSelected(e.target.value);
                setFilter("");
                setFilterList(lists);
              }}
              disabled={false}
              defaultValue="Select your Option"
              disabledDefaultValue={false}
              disableSelect={false}
            />
          </div>
          <div className="col-md-6">
            <Input
              placeHolder="filter list"
              type="String"
              name="message"
              value={filter}
              onChange={(e) => handleFilterData(e.target.value)}
            />
          </div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Make</th>
            <th>Model</th>
            <th>Status</th>
            <th>Registration State</th>
            <th>Registration Number</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {FilterList.map((car) => (
            <tr key={car.car_uid}>
              <td>{car.make}</td>
              <td>{car.model}</td>
              <td>{handleStatus(car.car_latest_status)}</td>
              <td>{car.registration_state}</td>
              <td>{car.registration_number}</td>
              <td>{handleButtonControl(car)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CarLists;
